<template>
    <div>
        <div class="slide_header">
            <div class="grid grid-cols-3 gap-4 title_slide">
                <div class="col-span-3 font-bold text-center text-2xl">Hướng dẫn {{ data.length }} bước đăng ký vay</div>
            </div>
            <vue-glide v-if="data.length > 0" class="mgt-10 slide_mobile" :perView="1" type="carousel" :peek="{ before: 0, after: 30 }" v-model="active">
                <vue-glide-slide v-for="i in data" :key="i.id">
                    <div>
                        <div class="image_slide cursor-pointer">
                            <img :src="i.image" fluid alt="vclick slide step">
                        </div>
                        <div class="slide_title fw-700 mgt-10 ft-16 cursor-pointer">
                            {{ i.name }}
                        </div>
                    </div>
                </vue-glide-slide>
            </vue-glide>
        </div>
        <div class="mt-3 container max-w-6xl slide_pc">
            <div class="mt-2 grid grid-cols-8 m-auto text-center">
                <div class="md:col-span-1 col-span-8 ">
                </div>
                <div class="md:col-span-2 col-span-8 border-wrap-phone">
                    <vue-glide v-if="data.length > 0" :bullet="true" :perView="1" :peek="{ before: 0, after: 0 }" type="carousel" v-model="active">
                        <vue-glide-slide v-for="i in data" :key="i.id">
                            <div>
                                <div >
                                    <img :src="i.image" style="" fluid alt="vclick slide step">
                                </div>
                            </div>
                        </vue-glide-slide>
                        <!-- <template class="absolute bottom-0 left-0" slot="control">
                            <button class="bg-red-500" data-glide-dir="<">prev<i class="fas fa-chevron-left"></i></button>
                            <button class="bg-red-500" data-glide-dir=">">next</button>
                        </template> -->
                    </vue-glide>
                </div>
                <div class="md:col-span-5 col-span-8">
                    <div class="grid grid-cols-6 p-3 text-left">
                        <div class="col-span-5">
                            <div class="text-lg"  v-for="(i,index) in data" :key="i.id">
                                <div v-if="active == index" class="step_slide step_slide-active">
                                    <div  class="number_step glide__bullet" data-glide-dir="3">{{ index+1 }}</div>{{ i.name }}
                                </div>
                                <div v-else class="step_slide step_slide" @click="active = index">
                                    <div  class="number_step glide__bullet" data-glide-dir="3">{{ index+1 }}</div>{{ i.name }}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Glide, GlideSlide } from 'vue-glide-js'
import { getListBlog } from '@/api/otp'
import 'vue-glide-js/dist/vue-glide.css'

export default {
    props: ['data'],
    components: {
        [Glide.name]: Glide,
        [GlideSlide.name]: GlideSlide
    },
    data(){
        return{
            active: 0,
            data: [
                // {id: "1", image: "https://static.topdev.site/vclick/news/1670986662.webp", name: "Bước 1: Đây là bước 1 "},
                // {id: "2", image: "https://static.topdev.site/vclick/news/1671007664.webp", name: "Bước 2: Đây là bước 2 "},
                // {id: "3", image: "https://static.topdev.site/vclick/news/1670986662.webp", name: "Bước 3: Đây là bước 3 "},
                // {id: "4", image: "https://static.topdev.site/vclick/news/1670986662.webp", name: "Bước 4: Đây là bước 4 "}
            ]
        }
    },
    methods: {
        getSlideStep(){
            getListBlog({
                category_slug: "huong-dan-fastmoney",
                partner: "fastmoney",
                sort: "asc"
            }).then(res => {
                this.data = res.data
            })
        }
    },
    created(){
        this.getSlideStep()
    }
}
</script>

<style>
.title_slide_header {
    font-family: Arial;
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 133%;
    letter-spacing: -0.03em;
    /* color: #34404B; */
}
.slide_pc .glide {
    /* width: 90% !important; */
    /* margin-left: 50px;
    margin-top: 40px; */
}
.slide_pc .step_slide {
    font-weight: 500;
    height: 80px;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: 50px;
}
.slide_pc .number_step {
    background-color: #fad7e6;
    color: #f1674a;
    border-radius: 9999px;
    justify-content: center;
    align-items: center;
    height: 2rem;
    width: 2rem;
    display: flex;
    font-family: Nunito, sans-serif;
    margin-right: 20px;
}
.step_slide-active {
    color: #f1674a;
}
.step_slide-active .number_step {
    background-color: #f1674a;
    color: white;
}
.slide_pc .glide__slide img {
    /* height: 265px;
    width: 100%;
    border-radius: 10px; */
}

.glide__bullets{
    height: 0px;
}
.slide_header .image_slide {
    border-radius: 10px;
}
.title_slide {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 133%;
    margin-bottom: 15px;
}
.image_slide img {
    width: 96%;
    height: 313px;
    border-radius: 10px;
}
.slide_title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: -0.03em;
    color: #34404B;
    margin-top: 15px;
}
.slide_content {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 142%;
    letter-spacing: -0.03em;
    color: #9AA0A5;
    margin-top: 15px;
    width: 96%;
}
.slide_content .time_format {
    text-align: right;
}
@media screen and (min-width: 768px) {
    .slide_mobile {
        display: none;
    }
    .slide_pc {
        display: block;
    }
    .title_slide_header {
        text-align: center;
    }
}
@media screen and (max-width: 767px) {
    .slide_mobile {
        display: block;
    }
    .slide_pc {
        display: none;
    }
    .slide_header {
        margin-left: 5%;
        margin-bottom: 30px;
    }
}
</style>